import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '../../base/base.component';
import { ErrorReportingService } from '../../services/errorReporting/error-reporting.service';
import { IngestFileTreeComponent } from './ingest-file-tree/ingest-file-tree.component';

@Component({
    selector: 'app-development-data',
    templateUrl: './development-data.component.html',
    styleUrls: ['./development-data.component.css'],
    standalone: false
})
export class DevelopmentDataComponent extends BaseComponent {

  @ViewChild(IngestFileTreeComponent) ingestFileTree: IngestFileTreeComponent;

  constructor(matDialog: MatDialog, errorLogger: ErrorReportingService) {
    super(errorLogger, matDialog);
  }

  onIngestFilesUploaded(): void {
    this.ingestFileTree?.refresh();
  }
}
